import React from 'react';
import cn from 'classnames';
import styles from './ClearedActivity.module.scss';
import star from '/img/inbox/star.svg?url';
import ViewMessage from '@components/ViewMessage';
import {
  BirthdayActivityIcon,
  EventActivityIcon,
  NewMemberActivityIcon,
  NewsActivityIcon,
  ReconnectActivityIcon,
  ReminderActivityIcon,
  SharedActivityIcon,
  ImportActivityIcon,
  PostActivityIcon,
  SocialProfileChangesActivityIcon,
} from '../ActivityTypeIcons';
import { useSelector } from 'react-redux';
import { selectActiveActivityFilter } from '@reducers/data/activity';
import { AppState } from '@reducers/rootReducer';
import { ActivityItemType } from '@models/Activity';
import { useTheme } from '@support/hooks/use-theme';

const iconByActivityType = {
  'birthday': <BirthdayActivityIcon />,
  'event': <EventActivityIcon />,
  'import': <ImportActivityIcon />,
  'new-member': <NewMemberActivityIcon />,
  'news': <NewsActivityIcon />,
  'post': <PostActivityIcon />,
  'reconnect': <ReconnectActivityIcon />,
  'reminder': <ReminderActivityIcon />,
  'shared': <SharedActivityIcon />,
  'diff': <SocialProfileChangesActivityIcon />,
};

const messageByActivityType = {
  'birthday': 'Upcoming birthdays will show up here.',
  'event': 'Your events will show up here.',
  'import': (
    <>
      You'll see when people have been
      <br />
      imported into Clay here.
    </>
  ),
  'new-member': (
    <>
      You'll find out when people
      <br />
      you know join Clay here.
    </>
  ),
  'news': (
    <>
      You'll see when people you know
      <br />
      are in the news here.
    </>
  ),
  'post': (
    <>
      Notable posts from people you
      <br />
      know will show up here.
    </>
  ),
  'reconnect': (
    <>
      Your recommendations for reconnecting
      <br />
      with people will show up here.
    </>
  ),
  'reminder': 'Reminders you set will show up here.',
  'shared': (
    <>
      People and groups shared with you
      <br />
      will show up here.
    </>
  ),
  'diff': (
    <>
      Changes to people's Twitter profiles
      <br />
      will show up here.
    </>
  ),
};

const activityMessage = 'Check back later for more.';

export default function ClearedActivity({
  selectAppliedFilter = selectActiveActivityFilter,
}: {
  selectAppliedFilter?: (appState: AppState) => ActivityItemType;
}) {
  const activeFilter = useSelector(selectAppliedFilter);
  const [theme] = useTheme();
  const icon = iconByActivityType[activeFilter] || (
    <img className={cn(styles.image, styles.starImage, styles[theme])} src={star} />
  );
  const message = messageByActivityType[activeFilter] || activityMessage;

  return (
    <div className={styles.container}>
      <ViewMessage
        className={styles.message}
        icon={icon}
        headline="All Caught Up!"
        message={message}
      />
    </div>
  );
}
